export const PLAYER_ROLES = ['PLAYER', 'FREEAGENT', 'CAPTAIN'];
